var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEncours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3167 6.6399C15.3167 8.11495 16.4446 9.24293 17.9197 9.24293C19.3947 9.24293 20.5227 8.11495 20.5227 6.6399C20.5227 5.16485 19.3947 4.03687 17.9197 4.03687C16.4446 4.03687 15.3167 5.16485 15.3167 6.6399Z",
    fill: "#F72717",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67676 3.16919C9.67676 4.38394 10.6312 5.33838 11.846 5.33838C13.0607 5.33838 14.0151 4.38394 14.0151 3.16919C14.0151 1.95444 13.0607 1 11.846 1C10.6312 1 9.67676 1.95444 9.67676 3.16919Z",
    fill: "#F72717",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60303 4.90451C3.60303 6.11926 4.55747 7.07371 5.77222 7.07371C6.98697 7.07371 7.94141 6.11926 7.94141 4.90451C7.94141 3.68977 6.98697 2.73532 5.77222 2.73532C4.55747 2.73532 3.60303 3.68977 3.60303 4.90451Z",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.1107C1 11.0651 1.78091 11.846 2.73535 11.846C3.6898 11.846 4.47071 11.0651 4.47071 10.1107C4.47071 9.15621 3.6898 8.37531 2.73535 8.37531C1.78091 8.37531 1 9.15621 1 10.1107Z",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30151 15.3167C2.30151 16.2711 3.08242 17.052 4.03687 17.052C4.99131 17.052 5.77222 16.2711 5.77222 15.3167C5.77222 14.3622 4.99131 13.5813 4.03687 13.5813C3.08242 13.5813 2.30151 14.3622 2.30151 15.3167Z",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07373 18.7874C7.07373 19.4815 7.6811 20.0889 8.37525 20.0889C9.06939 20.0889 9.67676 19.4815 9.67676 18.7874C9.67676 18.0932 9.06939 17.4859 8.37525 17.4859C7.6811 17.4859 7.07373 18.0932 7.07373 18.7874Z",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1931 18.8741C12.1931 19.3948 12.5402 19.7418 13.0608 19.7418C13.5814 19.7418 13.9285 19.3948 13.9285 18.8741C13.9285 18.3535 13.5814 18.0065 13.0608 18.0065C12.5402 18.0065 12.1931 18.4403 12.1931 18.8741Z",
    stroke: "#F72717",
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncours);
export default __webpack_public_path__ + "static/media/Encours.ac9349ec03526e7d2ce6180e5e188e38.svg";
export { ForwardRef as ReactComponent };